import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FadeTransition from '../../../components/animations/FadeTransition'
import { ONBOARDING_STEP_EVENT } from '../../../constants/analyticEvents'
import { pushEvent } from '../../../utilities/analytics'
import { setCurrentStep, setDataV2 } from '../onboardingSlice'
import WizardNightsButton from '../components/WizardNightsButton'
import WizardRadioButton from '../components/WizardRadioButton'
import { getWizardV2State } from '../wizardService'
import { isMobile } from '../../../utilities/helpers'
import NightsStepDesktop from '../../wizardDesktop/steps/NightsStepDesktop'

const NightsStep = () => {
  const stepConfig = getWizardV2State().nightsStep;
  const dispatch = useDispatch();
  const limit = stepConfig.maxNights < 8 ? stepConfig.maxNights : 8;

  const { formV2: form, step } = useSelector(state => state.onboarding);
  const [weekendsDisabled, setWeekendsDisabled] = useState(!!(form.nights.length && isFinite(Math.max(...form.nights)) && Math.max(...form.nights) >= 5));
  const [showAll, setShowAll] = useState(Math.max(...form.nights) > limit);

  const getNightsToShow = () => {
    const nights = [];
    for (let index = 2; index <= (showAll ? stepConfig.maxNights : limit); index++) {
      nights.push(index);
    }

    return nights;
  }

  const nightsToShow = getNightsToShow();

  const showMoreButton = !showAll && stepConfig.maxNights > 8;

  const onNightClick = (night) => {
    let updatedNights = [...form.nights];
    let updatedWeekendsOnly = form.weekendsOnly;

    if (form.nights.includes(night)) {
      updatedNights = form.nights.filter(item => item !== night);
    } else {
      updatedNights = [...form.nights, night];
    }

    if (isFinite(Math.max(...updatedNights)) && Math.max(...updatedNights) >= 5) {
      updatedWeekendsOnly = false;
      setWeekendsDisabled(true);
    } else {
      setWeekendsDisabled(false);
    }

    dispatch(setDataV2({
      nights: updatedNights,
      weekendsOnly: updatedWeekendsOnly,
    }))
  }

  const onChangeWeekendsOnly = () => {
    if (!weekendsDisabled) {
      dispatch(setDataV2({ weekendsOnly: !form.weekendsOnly }));
    }
  }

  const onShowAllClick = () => {
    setShowAll(true);
  }

  const handleContinueClick = () => {
    dispatch(setCurrentStep(1));
    pushEvent(ONBOARDING_STEP_EVENT, {
      step,
      stepName: 'nights',
      question: stepConfig.title,
      selection: form.nights,
      weekendsOnly: form.weekendsOnly,
      skipAvailable: !!(localStorage.getItem('onboardingCompleted')),
    });
  }

  if (!isMobile()) {
    return (
      <NightsStepDesktop
        onNightClick={onNightClick}
        form={form}
        weekendsDisabled={weekendsDisabled}
        onChangeWeekendsOnly={onChangeWeekendsOnly}
        onContinueClick={handleContinueClick}
      />
    )
  }

  return (
    <div className="wizard-content-scrollable">
      <div className="wizard-step">
        <div className="wizard-step__title">{stepConfig.title}</div>
        <div className="wizard-step__subtitle">{stepConfig.subTitle}</div>
        <div className="wizard-step__options wizard-nights-step slide-in-bottom">
          {nightsToShow.map((night) => (
            <WizardNightsButton
              key={night}
              label={night}
              active={form.nights.includes(night)}
              onClick={() => onNightClick(night)}
            />
          ))}
          {showMoreButton && (
            <WizardNightsButton
              label={stepConfig.moreText}
              onClick={onShowAllClick}
            />
          )}
        </div>
          <div className="wizard-nights-step__weekends slide-in-bottom">
            <FadeTransition in={!weekendsDisabled} unmountOnExit>
                <WizardRadioButton
                  active={form.weekendsOnly}
                  label={stepConfig.weekendsOnlyText}
                  onClick={onChangeWeekendsOnly}
                  disabled={weekendsDisabled}
                />
            </FadeTransition>
          </div>
      </div>

      <div className="wizard-footer">
        <button className="wizard-control-button" onClick={handleContinueClick}>{stepConfig.buttonText}</button>
      </div>
    </div>
  )
}

export default NightsStep
